import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
//import { WebAppSharedModule } from '../shared';
import { NotificationComponent } from './';

import { TranslatePipeModule } from './../../language/language.module';

import { DialogNotificationService } from '../shared/components/dialog-notification/dialog-notification.service';
import { DialogNotificationComponent, DialogNotificationPopupComponent } from '../shared/components/dialog-notification/dialog-notification.component';

@NgModule({
    imports: [
        TranslatePipeModule,
        //RouterModule.forRoot([ ...NOTIFICATION_ROUTE ], { useHash: true })
    ],
    declarations: [
        NotificationComponent,

        DialogNotificationComponent,
        DialogNotificationPopupComponent,
    ],
    entryComponents: [
        DialogNotificationComponent,
        DialogNotificationPopupComponent,
    ],
    providers: [
        DialogNotificationService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class WebAppNotificationModule {}
